import styled from '@emotion/styled';
import { useTheme } from '@emotion/react';
import { CheckCircle, CircleDashed } from '@phosphor-icons/react';
import type { ReactNode } from 'react';

export type VerticalStepperProps = {
  isCompleted: boolean;
  content: ReactNode;
  showConnector?: boolean;
};

export const VerticalStepper = ({
  isCompleted,
  content,
  showConnector = true,
}: VerticalStepperProps) => {
  const theme = useTheme();
  return (
    <Container>
      <LeftSection>
        <StatusIcon>
          {isCompleted ? (
            <CheckCircle
              size={32}
              weight="fill"
              color={theme.palette.fg.successSecondary}
              data-testid="check-circle-icon"
            />
          ) : (
            <CircleDashed size={32} color="#9CA3AF" data-testid="circle-dashed-icon" />
          )}
        </StatusIcon>
        {showConnector && <Connector data-testid="vertical-stepper-connector" />}
      </LeftSection>
      <ContentWrapper>{content}</ContentWrapper>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  gap: ${p => p.theme.s.md};
  position: relative;
`;

const LeftSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
`;

const StatusIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
`;

const Connector = styled.div`
  width: 1px;
  flex: 1;
  background-color: ${p => p.theme.palette.border.primary};
  margin-top: ${p => p.theme.s.xxs};
  margin-bottom: ${p => p.theme.s.xxs};
  min-height: 84px;
`;

const ContentWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding-bottom: ${p => p.theme.s.lg};
`;
